/**
 * BANK-QUESTION-TAG-CHIPS
 * "Inversée" + scale cardinality chips, shared by the "Banque de questions" list, the editor's
 * suggestions and the manage modal's scan results (2026-09-21/22). Reverse uses the same color as
 * the editor's own reverse indicator (editor-question.widget.tsx, tagColor="#0079bf"). Scale points
 * is the mode across linked instances — null (no linked instance yet) shows nothing.
 */
import { useTranslation } from "react-i18next"
import Chip from "@/components/chip"
import { SCALE_POINTS_COLORS } from "@/features/benchmark/entities/question/model/scalePoints.utils"

interface Props {
  isReverse: boolean
  scalePoints: number | null
}

export default function BankQuestionTagChips(props: Props) {
  const { t } = useTranslation()

  return (
    <>
      {props.isReverse && (
        <Chip color="#0079bf" isWithMargin>
          {t("question_reverse_tag")}
        </Chip>
      )}
      {props.scalePoints != null && (
        <Chip color={SCALE_POINTS_COLORS[props.scalePoints]} isWithMargin>
          {t("benchmark_editor_supervisor_scale_points", { count: props.scalePoints })}
        </Chip>
      )}
    </>
  )
}
